import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { giphyBlack, giphyCharcoal } from '@giphy/colors'
import { ReactNode } from 'react'
import { UGELayer } from '../../../types'
import Header from './header'
import { Collapse, DragButton, Layer } from './style'

type Props = {
    children?: ReactNode
    className?: string
    draggable?: boolean
    layer: UGELayer
    open?: boolean
    onOpen?: (layerId: string) => void
}

const UGELayersEditorLayer = ({ children, className, draggable = false, layer, open, onOpen: onOpenProp }: Props) => {
    const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({ id: layer.id })

    const dragStyle = {
        transform: CSS.Translate.toString(transform),
        transition,
    }

    function onOpen(isOpen: boolean) {
        if (isOpen) {
            onOpenProp?.(layer.id)
        }
    }

    return (
        <Layer className={className} style={dragStyle}>
            <Collapse
                label={<Header dragging={isDragging} layer={layer} open={open} />}
                open={open}
                size="medium"
                onChange={onOpen}
            >
                {children}
            </Collapse>
            {draggable && (
                <DragButton
                    {...listeners}
                    {...attributes}
                    color={giphyBlack}
                    iconColor={giphyCharcoal}
                    icon="dragger"
                    ref={setNodeRef}
                    size="small"
                />
            )}
        </Layer>
    )
}

export default UGELayersEditorLayer
